import { useSyncExternalStore } from "react";

const showingFooters = new Set<symbol>();
const listeners = new Set<() => void>();

export function setFooterShowing(footer: symbol, showing: boolean): void {
    const before = showingFooters.size > 0;
    if (showing) showingFooters.add(footer);
    else showingFooters.delete(footer);
    if (before === showingFooters.size > 0) return;
    for (const listener of listeners) listener();
}

export function subscribeFooterShowing(listener: () => void) {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export function isFooterShowing() {
    return showingFooters.size > 0;
}

export function useFooterShowing() {
    return useSyncExternalStore(
        subscribeFooterShowing,
        isFooterShowing,
        () => false,
    );
}
